module.exports = __webpack_public_path__ + "static/foto2-e875dae7de00a770e57766f813939642.jpg";